import { gql, useLazyQuery } from '@apollo/client';

export const RESOLVE_WECOM_GROUP = gql`
  query ResolveWecomGroup($groupId: String!, $channelId: Long) {
    resolveWecomGroup(groupId: $groupId, channelId: $channelId) {
      groupName
      boundChannelName
    }
  }
`;

export interface WecomGroupResolveResult {
  /** 企微群名称；查不到、或已绑定其他客户时为 null */
  groupName?: string | null;
  /** 已绑定的其他客户名称；未绑定其他客户时为 null */
  boundChannelName?: string | null;
}

export interface ResolveWecomGroupResponse {
  resolveWecomGroup: WecomGroupResolveResult | null;
}

export interface ResolveWecomGroupVariables {
  groupId: string;
  /** 当前客户ID，新建客户时不传 */
  channelId?: number | null;
}

export const useResolveWecomGroup = () => {
  return useLazyQuery<ResolveWecomGroupResponse, ResolveWecomGroupVariables>(
    RESOLVE_WECOM_GROUP,
    { fetchPolicy: 'network-only' }
  );
};
